<template>
    <div class="h-fix flex overflow-hidden bg-gray-100">
        <mobile-nav :visible="isMenuVisible" @close="setMenuVisibility(false)" />

        <main-nav />

        <div class="flex flex-col w-0 flex-1 flex-no-wrap overflow-hidden">
            <div class="relative z-10 flex-shrink-0 flex h-16 bg-white shadow md:hidden">
                <button
                    aria-label="Open sidebar"
                    class="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:bg-gray-100 focus:text-gray-600 md:hidden"
                    @click="setMenuVisibility(true)"
                >
                    <svg
                        class="h-6 w-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            d="M4 6h16M4 12h16M4 18h7"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                        />
                    </svg>
                </button>
            </div>

            <main class="flex-1 relative z-0 overflow-y-auto py-6 focus:outline-none" tabindex="0">
                <div class="h-full mx-auto px-4 sm:px-6 md:px-8">
                    <router-view />
                </div>
            </main>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import MainNav from '../components/Nav/MainNav.vue';
    import MobileNav from '../components/Nav/MobileNav.vue';

    export default {
        components: {
            MainNav,
            MobileNav,
        },

        data() {
            return {
                isMenuVisible: false,
            };
        },

        computed: {
            ...mapState([
                'authUser',
            ]),
        },

        methods: {
            setMenuVisibility(visibility) {
                this.isMenuVisible = visibility;
            },
        },

        mounted() {
            // if (!(this.authUser.name && this.authUser.id)) {
            //     this.$router.push('/login');
            // }
        },
    };
</script>
